/**
 * Legacy sterilemate.com WordPress URL -> new React SPA route.
 *
 * Used by <WordPressRedirect /> (frontend/src/components/WordPressRedirect.jsx)
 * to catch legacy inbound traffic (Google, external links, bookmarks) and
 * send visitors to the correct page on the migrated Emergent app.
 *
 * When adding new marketing pages, also add the WordPress equivalent here
 * so we preserve link authority in Google Search Console.
 *
 * Source of truth is /app/backend/data/wordpress_redirects.json.
 */
export const WORDPRESS_REDIRECTS = {
  "/healthcare-water-purification": "/solutions/water-treatment",
  "/healthcare-water-purification-education": "/solutions/water-treatment#education",
  "/di-tank-exchange-service-for-healthcare-customers": "/solutions/water-treatment#di-exchange",
  "/di-tank-exchange": "/marketplace/di-tank-exchange",
  "/water-softener-systems": "/solutions/water-treatment#softeners",
  "/water-softeners": "/solutions/water-treatment#softeners",
  "/commercial-reverse-osmosis-water-purification-systems": "/solutions/water-treatment#ro",
  "/reverse-osmosis-tanks": "/solutions/water-treatment#reserve-tanks",
  "/standard-uv-systems": "/solutions/water-treatment#uv",
  "/general-contracting": "/solutions/general-contracting",
  "/general-contracting-services": "/solutions/general-contracting",
  "/sterile-processing-department": "/sterile-processing",
  "/spd": "/sterile-processing",
  "/evs": "/marketplace?category=evs-janitorial",
  "/evs-janitorial": "/marketplace?category=evs-janitorial",
  "/environmental-services": "/marketplace?category=evs-janitorial",
  "/janitorial": "/marketplace?category=evs-janitorial",
  "/gloves": "/marketplace/gloves",
  "/exam-gloves": "/marketplace/gloves",
  "/ammex": "/marketplace/gloves/ammex",
  "/ansell": "/marketplace/gloves/ansell",
  "/microflex": "/marketplace/gloves/microflex",
  "/neuro-sponges": "/marketplace/american-surgical",
  "/healthcare-furniture": "/marketplace/healthcare-examination-furniture",
  "/exam-furniture": "/marketplace/healthcare-examination-furniture",
  "/brewer": "/marketplace/healthcare-examination-furniture",
  "/ritter": "/marketplace/healthcare-examination-furniture",
  "/midmark": "/marketplace/healthcare-examination-furniture",
  "/millennium-series": "/marketplace/healthcare-examination-furniture",
  "/blood-drawing-chairs": "/marketplace/healthcare-examination-furniture",
  "/blood-draw-chair": "/marketplace/healthcare-examination-furniture",
  "/products": "/marketplace",
  "/shop": "/marketplace",
  "/backorder": "/",
  "/backorder-rfq": "/",
  "/hospital-supply-backorder": "/",
  "/quick-quote": "/",
  "/quote": "/",
  "/request-a-quote": "/",
  "/about-us": "/about",
  "/team": "/about",
  "/certifications": "/about",
  "/hub-mbe": "/about",
  "/contact-us": "/contact",
  "/services": "/solutions",
  "/wp-admin": "/",
  "/wp-login.php": "/",
  "/feed": "/",
  "/rss": "/",
  "/blog": "/",
  "/news": "/",
};

/**
 * Return the redirect target for a legacy WordPress path, or null if the
 * path isn't a known legacy route. Handles trailing slashes so both
 * "/ammex" and "/ammex/" hit the same rule.
 */
export function getWordpressRedirect(pathname) {
  if (!pathname) return null;
  // Normalize: strip trailing slash (except for root)
  const clean = pathname !== "/" && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;
  return WORDPRESS_REDIRECTS[clean] || null;
}
